import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useSessionGuard from 'hooks/useSession';
import AuthLoader from 'components/AuthLoader';
import { STATUS_DISCREPANCY_ALLOWED_USERNAMES, isStatusDiscrepancyDevUser } from 'config/devOnlyRoutes';

// ==============================|| DEV USER GUARD ||============================== //

/**
 * Restricts a route to an allow-list of usernames (hidden dev tools).
 */
export default function DevUserGuard({ children, allowedUsernames = STATUS_DISCREPANCY_ALLOWED_USERNAMES }) {
  const result = useSessionGuard();
  const navigate = useNavigate();

  const isAuthenticated = result.isLoggedIn ?? false;
  const isLoading = !(result.isInitialized ?? false);
  const username = result.user?.username ?? '';
  const isAllowed = isStatusDiscrepancyDevUser(username);

  useEffect(() => {
    if (!isLoading && isAuthenticated && !isAllowed) {
      navigate('/', {
        state: { accessDenied: true, message: 'Page not found.' },
        replace: true
      });
    }
  }, [isAuthenticated, isLoading, isAllowed, navigate]);

  if (isLoading || (isAuthenticated && !result.user?.username)) {
    return <AuthLoader />;
  }

  if (!isAuthenticated || !isAllowed) {
    return null;
  }

  return children;
}

DevUserGuard.propTypes = {
  children: PropTypes.any,
  allowedUsernames: PropTypes.arrayOf(PropTypes.string)
};
